import {reactive} from 'vue'
import UserData from "@/models/UserData";
import backendApi from "@/backend-api";
import {auth} from "@/scripts/authByVk"
import LoginForm from "@/models/LoginForm";
import NewPasswordForm from "@/models/NewPasswordForm";

const authState = reactive({
    userData: {} as UserData
})

const loginFormState = reactive({
    showLoginModal: false,
    form: {} as LoginForm,
    newPasswordForm: {} as NewPasswordForm,
    tab: "login",
    errorMessage: ""
})

const gRecaptchaKey= "6LcmlqoqAAAAAHlxgw5Q3W1IuEaag_iu7TIaUpEn"

function handleApiError(
        error: any,
        defaultMessage = "Произошла ошибка. Попробуйте позже."
) {
    console.log("error ", error.response)

    if (error.response) {
        const {status, data} = error.response;

        loginFormState.errorMessage = data?.message || defaultMessage
    } else {
        console.error("Ошибка сети или сервера:", error);
        alert(defaultMessage);
    }
}

const actions = {
    async signIn(captchaToken: string) {
        try {
            await backendApi.signIn({
                username: loginFormState.form.username,
                password: loginFormState.form.password,
                captchaToken: captchaToken
            });

            await actions.fetchUserData();
            actions.closeLoginModal();
        } catch (error) {
            handleApiError(error, "Не удалось выполнить вход");
        }
    },
    async signUp(captchaToken: string) {
        try {
            await backendApi.signUp({
                name: loginFormState.form.name,
                surname: loginFormState.form.surname,
                username: loginFormState.form.username,
                password: loginFormState.form.password,
                confirmPassword: loginFormState.form.confirmPassword,
                agreeTerms: loginFormState.form.agreeTerms,
                captchaToken: captchaToken
            });

            await actions.fetchUserData();
            actions.closeLoginModal();
        } catch (error) {
            handleApiError(error, "Не удалось завершить регистрацию");
        }
    },
    async initConfirmEmail(captchaToken: string, callback?: () => void) {
        try {
            await backendApi.initConfirmEmail({
                username: loginFormState.form.username,
                captchaToken: captchaToken
            });

            if (callback) {
                callback();
            }
        } catch (error) {
            handleApiError(error, "Не удалось отправить письмо");
        }
    },
    async initResetPassword(captchaToken: string, callback: () => void) {
        try {
            await backendApi.initResetPassword({
                username: loginFormState.form.username,
                captchaToken: captchaToken
            });

            callback();
        } catch (error) {
            handleApiError(error, "Не удалось запросить сброс пароля");
        }
    },
    async setNewPassword(captchaToken: string, callback: () => void) {
        try {
            await backendApi.setNewPassword({
                username: loginFormState.newPasswordForm.username,
                token: loginFormState.newPasswordForm.token,
                password: loginFormState.newPasswordForm.password,
                timestamp: loginFormState.newPasswordForm.timestamp,
                confirmPassword: loginFormState.newPasswordForm.confirmPassword,
                captchaToken: captchaToken
            });

            loginFormState.form.username = loginFormState.newPasswordForm.username;

            callback();
        } catch (error) {
            handleApiError(error, "Не удалось установить новый пароль");
        }
    },
    async fetchUserData() {
        try {
            const data = await backendApi.userData()
            Object.assign(authState.userData, data)

            if (authState.userData.redirectUrl) {
                window.location.href = authState.userData.redirectUrl
            }

            actions.setRiderNameToYaMetrika(
                    authState.userData.riderFullName
            )

        } catch (error) {
            handleApiError(error, "Не удалось загрузить данные пользователя");
        }
    },
    async setRiderNameToYaMetrika(riderFullName: string) {
        if ((window as any).Ya && riderFullName) {
            (window as any).Ya._metrika.counter.params({
                riderFullName: riderFullName
            })
        }
    },
    async authByVk(closeModalCallback: () => void) {
        console.log("authState.userData.vkLink", authState.userData.vkLink)
        await auth(authState.userData.vkLink, async () => {
            await actions.fetchUserData()
            closeModalCallback()
        })
    },
    async logout() {
        try {
            await backendApi.logout();
            await actions.fetchUserData();
        } catch (error) {
            handleApiError(error, "Не удалось выйти из системы.");
        }
    },
    openLoginModal(tab = 'login') {
        loginFormState.showLoginModal = true;
        loginFormState.tab = tab;
    },
    closeLoginModal() {
        loginFormState.showLoginModal = false;
    },
    clearErrorMessage() {
        loginFormState.errorMessage = ""; // Очищаем сообщение об ошибке
    },
}

export default {
    loginFormState,
    authState,
    ...actions,
    gRecaptchaKey: gRecaptchaKey
}

